<script lang="ts">
  import { BRAND_NAME } from '../lib/brand';
  import { get } from 'svelte/store';
  import { replace } from 'svelte-spa-router';
  import Logo from './Logo.svelte';
  import { hasInAppHistory } from '../lib/nav';
  interface Props {
    title?: string;
    backHref?: string;
    showLogo?: boolean;
  }
  let { title, backHref, showLogo = true }: Props = $props();

  function goBack(e: MouseEvent): void {
    e.preventDefault();
    // If the user navigated within the app, browser history restores the exact
    // page they came from (catalog, favorites, section, etc.).
    if (get(hasInAppHistory)) {
      window.history.back();
      return;
    }
    // Cold landing — e.g. a Telegram deep link straight to a material. There's
    // no in-app predecessor, so go to backHref via `replace` (not push): this
    // drops the landing screen from history, so the user can't be bounced back
    // onto it. We can't trust window.history.length here either — inside the
    // Telegram WebView it counts the WebView's own entries.
    if (backHref) replace(backHref);
  }
</script>

<div class="topbar">
  {#if backHref}
    <a class="back-btn" href={`#${backHref}`} onclick={goBack}>← Назад</a>
  {/if}
  {#if showLogo && !backHref}
    <div class="topbar-logo">
      <Logo size={28} />
      <span class="topbar-logo-text">{title ?? BRAND_NAME}</span>
    </div>
  {:else if title}
    <div class="topbar-title">{title}</div>
  {/if}
  {#if backHref}
    <!-- spacer mirrors back-btn so title flexes into the centre of the remaining row -->
    <div class="topbar-spacer" aria-hidden="true"></div>
  {/if}
</div>

<style>
  .topbar {
    padding: 14px 18px 12px;
    border-bottom: 0.5px solid var(--border);
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    background: var(--bg);
    position: relative;
  }
  .topbar-logo {
    display: flex;
    align-items: center;
    gap: 8px;
    color: var(--logo);
  }
  .topbar-logo-text {
    font-size: 14px;
    font-weight: 600;
    color: var(--logo);
    letter-spacing: 0.3px;
  }
  .topbar-title {
    flex: 1;
    min-width: 0;
    text-align: center;
    font-size: 14px;
    font-weight: 600;
    color: var(--text);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .back-btn,
  .topbar-spacer {
    flex-shrink: 0;
    min-width: 64px;
  }
  .back-btn {
    font-size: 12px;
    color: var(--text-muted);
    cursor: pointer;
    padding: 2px 0;
    text-decoration: none;
  }
</style>
